import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Icon } from '@pinpoint/design-kit';
import ClientFeedback from 'src/components/dialogs/clientFeedback';
import { APP } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

function Feedback() {
  const [isOpen, showConfirmModal] = useState(false);
  const dispatch = useDispatch();
  const submitFeedbackStatus = useSelector(({ app: { submitFeedbackStatus: status } }) => status);

  useEffect(() => {
    if (submitFeedbackStatus === CONSTANTS.API.STARTED) {
      dispatch({
        type: APP.ENQUEUE_NOTIFICATION,
        payload: {
          message: 'Thanks for taking your time to submit your feedback',
          options: { autoClose: true },
        },
      });
    } else if (submitFeedbackStatus === CONSTANTS.API.FAILED) {
      dispatch({
        type: APP.ENQUEUE_NOTIFICATION,
        payload: {
          message: "We couldn't submit your feedback. Please try again later",
          options: {},
        },
      });
    }
  }, [submitFeedbackStatus, dispatch]);

  return (
    <>
      <Icon
        name="Feedback"
        m={{ x: '1rem' }}
        color="shade66"
        size="1.5rem"
        hoverColor="brand400"
        onClick={() => showConfirmModal(true)}
        cursor="pointer"
        data-tip="Share feedback"
      />
      <ClientFeedback
        isOpen={isOpen}
        actions={{
          close: {
            on: () => showConfirmModal(false),
          },
          cancel: {
            on: () => {},
          },
          handlers: [
            {
              on: dispatch,
            },
          ],
        }}
      />
    </>
  );
}

export default Feedback;
